import { AccountFeatures, AppContext } from '@lightspeed-invoicing/core-client/frontend';
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import Tabs from "../tabs.component";

class SalesToolsTabs extends Component {

    constructor(props, context) {
        super(props, context)
    }


    render() {
        let tabs = [
            {
                name: <FormattedMessage
                    id="menu.tabs.sales_tools.branding"
                    defaultMessage="Branding"
                />,
                link: '/branding',
            },
            {
                name: <FormattedMessage
                    id="menu.tabs.sales_tools.custom_fields"
                    defaultMessage="Custom fields"
                />,
                link: '/custom-field-definitions/listing',
            },
            {
                name: <FormattedMessage
                    id="menu.tabs.sales_tools.relationships"
                    defaultMessage="Product relationships"
                />,
                link: '/relationships/listing',
            },
            {
                name: <FormattedMessage
                    id="menu.tabs.sales_tools.labels"
                    defaultMessage="Labels"
                />,
                link: '/labels/listing',
            },
        ]

        if (AppContext.accountFeatureIsEnabled(AccountFeatures.FeatureScheduling)) {
            tabs.push(
                {
                    name: <FormattedMessage
                        id="menu.tabs.sales_tools.calendars"
                        defaultMessage="Calendars"
                    />,
                    link: '/calendars/listing',
                }
            )
        }
        tabs.push(
            {
                name: <FormattedMessage
                    id="menu.tabs.sales_tools.bottom_line"
                    defaultMessage="Bottom Line"
                />,
                link: '/bottom-line/edit',
            }
        )
        return (
            <Tabs value={tabs} />
        );
    }
}

export default SalesToolsTabs


// WEBPACK FOOTER //
// ./src/common/layout/tabs/salestools.component.jsx